import { Dispatch } from 'redux';
import { UserModel } from '../../models/user.model';
import { AuthService } from '../../services/auth.service';

// Create Action Constants
export enum UserActionTypes {
    GET_USER_INFO = 'GET_USER_INFO',
    SET_ISLOGINED = 'SET_ISLOGINED'
}

export interface UserInfoAction {
    type: UserActionTypes.GET_USER_INFO;
    user: UserModel;
}

export interface SetIsLoginedAction {
    type: UserActionTypes.SET_ISLOGINED;
    isLoggined: boolean;
}


export type UserActions = UserInfoAction | SetIsLoginedAction;


export const setUserInfoToAppState = () => async (dispatch: Dispatch) => {
    let user = AuthService.getUserInfo();
    if (!user) {
        const res = await AuthService.getUserInfoAsync();
        user = res.data.current_user;
        AuthService.setUserInfo(user);
    }
    dispatch({
        user: user,
        type: UserActionTypes.GET_USER_INFO,
    })
}

export const setIsLogined = (value: boolean) => async (dispatch: Dispatch) => {
    dispatch({
        isLoggined: value,
        type: UserActionTypes.SET_ISLOGINED,
    })
}


